import React from 'react'
import BackButton from '../../../../components/BackButton'
import LanguageStrings from '../../../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import HybridKekInformation from './HybridKekInformation'
import { Button } from '../../../../components/Button'
import { Card, CircularProgress } from '@mui/material'
import { type Option } from '../../../../components/GenXDropdown'
import Modal from '../../../../components/Modal'
import { type CreateHybridKekPostRequest } from '../../types'
import { createHybridKek } from '../../redux/actionCreator'
import { type RootState } from '../../../../store'
import { type ConnectedProps, connect } from 'react-redux'
import AuthError from '../../../../components/ErrorComponents/AuthError'
import { type CreateHybridKekState } from '../../redux/hybrid/createHybridKekSlice'

const CreateHybridKekComponentStrings = LanguageStrings().HSMConfiguration.CreateHybridKekComponent

const AddHybridKekComponent = (props: PropsFromRedux): JSX.Element => {
  const [label, setLabel] = React.useState('')
  const [tenant, setTenant] = React.useState<Option | null>(null)
  const [regularLabel, setRegularLabel] = React.useState<Option | null>(null)
  const [error, setError] = React.useState<boolean>(false)
  const [descError, setDescError] = React.useState<boolean>(false)
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [nameErrorInit, setNameErrorInit] = React.useState(false)
  const [tenantOptions, setTenantOptions] = React.useState<Option[]>([])
  const [regularLabelOptions, setRegularLabelOptions] = React.useState<Option[]>([])
  const navigate = useNavigate()

  const resetGroupState = (): void => {
    setLabel('')
    setTenant(null)
    setRegularLabel(null)
    setError(false)
    setDescError(false)
    setNameErrorInit(false)
  }

  const handeleCancelClick = (): void => {
    resetGroupState()
    navigate(-1)
  }

  const handleCreateKek = (): void => {
    props.createKek({
      wrap: regularLabel !== null ? regularLabel.value : '',
      label,
      tenant: tenant !== null ? tenant.value : ''
    })
  }

  const checkIfKekInfoValid = (): boolean => {
    return (label !== '' && tenant !== null && regularLabel !== null && !error && !descError)
  }

  const handleCreateKekWithFailure = (): JSX.Element => {
    if (props.createKekState.httpStatus === 200) {
      return (
                <Modal buttonTypeNegative='hollow' title={CreateHybridKekComponentStrings.HybridKekHasBeenCreatedSuccessfully} LabelPositive={CreateHybridKekComponentStrings.Ok} onClickPositive={() => { navigate('/hsm-hybrid-kek-configuration') }}
                       onClose={() => { navigate('/hsm-hybrid-kek-configuration') }}>
                    <p style={{ paddingTop: '1.2em' }}>{CreateHybridKekComponentStrings.HybridKekHasBeenCreatedSuccessfully}</p>
                </Modal>
      )
    } else if (props.createKekState.isLoading) {
      return (
                <Modal title={CreateHybridKekComponentStrings.CreatingHybridKEK}>
                    <div className='CircularprogressAmi'>
                        <CircularProgress />
                    </div>
                </Modal>
      )
    } else if (props.createKekState.httpStatus === 401) {
      return (
                <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateHybridKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateHybridKekComponentStrings.CreatingHybridKEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} errorMessage="Unauthorized"/>
                    </div>
                </Modal>
      )
    } else if (props.createKekState.httpStatus === 403) {
      return (
                <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateHybridKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateHybridKekComponentStrings.CreatingHybridKEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} errorMessage="accessForbidden"/>
                    </div>
                </Modal>
      )
    } else if (props.createKekState.httpStatus === 400) {
      return (
          <Modal width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateHybridKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
               onClose={() => { setShowCreatePopup(false) }} title={CreateHybridKekComponentStrings.CreatingHybridKEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} customError={props.createKekState.error} />
                    </div>
                </Modal>
      )
    } else {
      return (
                <Modal width={'fit-content'} height={'fit-content'} buttonTypeNegative='hollow' LabelNegative={CreateHybridKekComponentStrings.Close}
                       onClickNegative={() => { setShowCreatePopup(false) }}
                       onClose={() => { setShowCreatePopup(false) }} title={CreateHybridKekComponentStrings.CreatingHybridKEK}>
                    <div className='authError'>
                        <AuthError className={'errorCompInsideModal'} customError={props.createKekState.error} />
                    </div>
                </Modal>
      )
    }
  }

  return (
        <div style={{ width: 'calc(100vw - 3.5rem)', paddingRight: '2rem' }}>
            <div className='link-breadcrumb'>
                <span data-testid='assetManagementbreadcrumb' onClick={ () => { navigate('/card') }} className='assetmgmtli'>{CreateHybridKekComponentStrings.HSMKeyManagement}</span>
                <span style={{ padding: '0 0.5em' }}>/</span>
                <span onClick={() => { navigate('/hsm-hybrid-kek-configuration') }} className='assetmgmtli'>{CreateHybridKekComponentStrings.HybridKeks}</span>
                <span style={{ padding: '0 0.5em' }}>/</span>
                <span>{CreateHybridKekComponentStrings.AddHybridKEK}</span>
            </div>
            <div className='topUtilityBar'>
                <BackButton/>
                <span id='componentTitle' data-testid='create-group'>{CreateHybridKekComponentStrings.CreatingHybridKEK}</span>
            </div>
            <br />
            {
                        <Card sx={{ borderRadius: '10px', backgroundColor: '#272727', color: '#F0F0F0 !important', padding: '25px', overflow: 'visible' }}>
                            <div style={{ height: 2, borderTop: '2px solid #707070', width: '100%', margin: '20px 0' }}></div>
                            <HybridKekInformation
                                error={error}
                                setError={setError}
                                label={label}
                                setLabel={setLabel}
                                tenant={tenant}
                                setTenant={setTenant}
                                regularLabel={regularLabel}
                                setRegularLabel={setRegularLabel}
                                setNameErrorInit={setNameErrorInit}
                                nameErrorInit={nameErrorInit}
                                tenantOptions={tenantOptions}
                                setTenantOptions={setTenantOptions}
                                regularLabelOptions={regularLabelOptions}
                                setRegularLabelOptions={setRegularLabelOptions}/>
                        </Card>
            }
            <div style={{ width: '100%', height: '80px', backgroundColor: '#272727', margin: '50px 0 10px 0', borderRadius: 10 }}>
                <div style={{ height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1em' }}>
                    <div>
                        <Button type='hollow' onClick={() => { handeleCancelClick() }}>{CreateHybridKekComponentStrings.Cancel}</Button>
                    </div>
                        {

                                <Button dataTestId='next-btn-select'
                                                                                  primaryColor={checkIfKekInfoValid() ? undefined : '#B0B0B0'}
                                                                                  disabled={!checkIfKekInfoValid()}
                                                                                  onClick={() => {
                                                                                    setShowConfirmation(true)
                                                                                  }}>
                                {CreateHybridKekComponentStrings.Create}
                            </Button>

                        }
                </div>
            </div>
            { showConfirmation &&
                <Modal buttonTypeNegative='hollow' title={CreateHybridKekComponentStrings.Create} LabelNegative={CreateHybridKekComponentStrings.Cancel} LabelPositive={CreateHybridKekComponentStrings.Create} onClickPositive={() => {
                  setShowConfirmation(false)
                  setShowCreatePopup(true)
                  handleCreateKek()
                }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
                    <p style={{ paddingTop: '1.2em' }}>{CreateHybridKekComponentStrings.DoYouWantToCreateThisHybridKek}</p>
                </Modal>
            }
            {
                showCreatePopup &&
                handleCreateKekWithFailure()
            }
        </div>
  )
}

interface DispatchToProps {
  createKek: (createHybridKekPostRequest: CreateHybridKekPostRequest) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  createKek: (createGroupPostRequest: CreateHybridKekPostRequest) => dispatch(createHybridKek(createGroupPostRequest))
})

interface StateToProps {
  createKekState: CreateHybridKekState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  createKekState: state.createHybridKekState
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AddHybridKekComponent)
export { AddHybridKekComponent as UnconnectedAddHybridKekComponent }
